import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import createMemoizedSelector from 'redux/selectors/createMemoizedSelector';
var getPipelineReadySltList = function getPipelineReadySltList() {
  return function (sltState) {
    var ids = sltState.ids;
    return ids.map(function (id) {
      return sltState[id];
    }).filter(Boolean).sort(function (a, b) {
      return new Date(b.updatedAt) - new Date(a.updatedAt);
    }).filter(function (slt) {
      return slt.kit && slt.samplesData && slt.samplesData.length > 0;
    });
  };
};
export default createMemoizedSelector(getPipelineReadySltList);